module.exports = __webpack_public_path__ + "assets/images/custom-logo-bg.png";